import PropTypes from "prop-types";
// material
import {
  TableRow,
  TableCell,
  TableHead,
  Typography,
  Stack,
  TextField,
  Checkbox,
} from "@mui/material";

ListHead.propTypes = {
  headLabel: PropTypes.array,
};

export default function ListHead({
  headLabel,
  stack,
  setStack,
  onSelectAllClick,
  numSelected,
  rowCount,
}) {
  const handleChangeStack = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setStack((values) => ({ ...values, [name]: value }));
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox"> */}
        {/* <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
              /> */}
        {/* </TableCell> */}
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignRight ? "right" : "left"}
            className={
              headCell.id == "actions"
                ? `${headCell?.className ? headCell?.className : " "} table_header_action_cell`
                : ""
            }
            sx={{
              textAlign: headCell.alignRight ? "right !important" : "left",
            }}
          >
            {headCell?.type === "text" ? (
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  width: "8rem",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                }}
                className="payroll-header"
              >
                <TextField
                  sx={{ width: "100%", fontWeight: "bold" }}
                  InputLabelProps={{ shrink: true }}
                  required
                  type="text"
                  name={headCell.id}
                  id="outlined-basic-payroll-header"
                  variant="standard"
                  onChange={handleChangeStack}
                  value={stack[headCell.id]}
                  className="payroll-header"
                />
              </Stack>
            ) : (
              <>
                {headCell.checkbox == true ? (
                  <>
                    {headCell.label && (
                      <Typography
                        sx={{ fontWeight: "bold" }}
                        component={"span"}
                      >
                        {headCell.label}
                      </Typography>
                    )}
                    <Checkbox
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={rowCount > 0 && numSelected === rowCount}
                      onChange={onSelectAllClick}
                    />
                  </>
                ) : (
                  <Typography sx={{ fontWeight: "bold" }}>
                    {headCell.label}
                  </Typography>
                )}
              </>
            )}
            {/* <TableSortLabel
                  hideSortIcon
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
                  ) : null}
                </TableSortLabel> */}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
